import {Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { ModelCurrency } from '../../../../models/currency.model';
import { LocalStorageManager } from '../../../../utils/local-storage-manager/local-storage-manager.utils';
import { PreferencesModel } from '../../../../models/preferences.model';
import { TranslateService } from '@ngx-translate/core';
import {CurrencyModel} from '../../../../models/general/currency.model';
import {Api3Service} from '../../../../services/api-3.service';
import Swal from 'sweetalert2';
import {ModalDeleteInfo} from '../../../../components/modals/modal-delete/modal-delete.component';
import {CurrenciesService} from '../../../../shared/services/currencies.service';

@Component({
  selector: 'app-modal-currencies',
  templateUrl: './modal-currencies.component.html',
  styleUrls: ['./modal-currencies.component.css']
})
export class ModalCurrenciesComponent implements OnInit {

  @Input() set isModalCalled(value: boolean) {
    value ? this.scrollToCurrency() : null;
  }

  @Input() currencies: CurrencyModel[] = [];
  @Input() currentCurrency?: CurrencyModel = undefined;

  @Output() emitter = new EventEmitter<CurrencyModel>();
  fkUser: number = 0;
  ls = LocalStorageManager;
  preferences = PreferencesModel.shared;
  isModalAddCurrencyCalled: boolean = false;
  currencySelect?: CurrencyModel;
  informationDelete: ModalDeleteInfo = {
    title: 'titles.title_confirm',
    body: 'question_messages.question_delete_movement',
    confirmText: 'buttons.button_yes',
    cancelText: 'buttons.button_cancel'
  };


  constructor(
    private translate: TranslateService,
    private api3: Api3Service,
    private currencyServices: CurrenciesService
  ) {
    let lang = LocalStorageManager.lang;
    this.translate.use(lang!);
    this.fkUser = this.api3.userData?.user_id ?? 1;
  }

  ngOnInit(): void {

  }

  setCurrency(currency: CurrencyModel) {
    let value = !currency.click
    this.currencies.forEach(row => row.click = false)
    currency.click = value;
  }

  selectCurrency(currency: CurrencyModel) {
    this.currentCurrency = currency;
  }

  setEdit(currency: CurrencyModel) {
    if (currency.isOwner) {
      this.currencySelect = currency;
      ($('#app-modal-add-currency') as any).modal('show');
    } else {
      this.showAlert("currency_section.currency_message_no_update")
    }
  }

  setDelete(currency: CurrencyModel) {
    if (currency.isOwner) {
      this.currencySelect = currency;
      ($('#ModalDeleteCurrency') as any).modal('show');
    } else {
      this.showAlert("currency_section.currency_message_no_delete")
    }
  }

  confirmCurrency() {
    this.emitter.emit(this.currentCurrency);
  }

  confirmDelete(ok: boolean) {
    if (!ok) { return }
    this.requestDelete();
  }

  scrollToCurrency() {
    setTimeout(() => {
      const element = document.getElementById(this.currentCurrency?.isoCode ?? "");
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }, 700);
  }

  showModalAddCurrency() {
    //this.isModalAddCurrencyCalled = !this.isModalAddCurrencyCalled
  }

  //MARK: PRIVATE METHODS ----------------------------------------------------------------------------
  private syncCurrencies() {
    this.currencyServices.getCurrencies().then(_ => {
      this.currencies = this.currencyServices.currencies;
      this.currencies.forEach(row => row.isOwner = (row.fkUser == this.fkUser));
    });
  }

  private requestDelete() {
    this.currencyServices.deleteCurrency(this.currencySelect!).then(_ => {
      this.currencies = this.currencies.filter(row => row != this.currencySelect);
      this.currencySelect = undefined;
    }, reject => {

    });
  }

  private showAlert(key: string) {
    const text = this.translate.instant(key);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      background: this.ls.isDarkmode ? '#212429' : '#FFF',
      color: this.ls.isDarkmode ? '#FFF' : '#212429',
      confirmButtonColor: '#D4AEF6',
      text,
      timer: undefined
    }).then(r => { });
  }
}
